import { FormControl, FormGroup, FormLabel, MenuItem, OutlinedInput, Select, Theme, useTheme   } from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchBusinesses } from '../../store/action_creators/business.actions';
import { toggleResetClientFilter } from '../../store/action_creators/payments.actions';
import { fetchAllUsers } from './../../store/action_creators/collaborators.actions';
import { Business, BusinessState, RootState } from './../../store/config/types';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      [theme.breakpoints.down('md')]: {
        maxHeight: '50vh',
        overflow: 'auto',
      },
    },
  }),
);
interface ClientsFilterProps {
  filterByBusiness(business: Business | null): void;
  resetTrigger?: boolean;
  setResetTrigger?(value: boolean): void;
  showPlexoNames?: boolean;
}

function ClientsFilter({
  filterByBusiness,
  resetTrigger,
  setResetTrigger,
  showPlexoNames,
}: ClientsFilterProps) {
  const classes = useStyles(useTheme());
  const dispatch = useDispatch<any>();
  const business: BusinessState = useSelector((state: RootState) => state.business);
  const resetClientFilter = useSelector((state: RootState) => state.payments.resetClientFilter);
  const [selectedBusiness, setSelectedBusiness] = useState<string>('');

  useEffect(() => {
    if (
      !business.loadingBusinesses &&
      business.businesses === null &&
      business.businessesErrorMessage === null
    ) {
      dispatch(fetchBusinesses());
    }
  }, [business.loadingBusinesses, business.businesses, business.businessesErrorMessage, dispatch]);

  useEffect(() => {
    if (resetClientFilter) {
      handleClientChange(null);
      dispatch(toggleResetClientFilter());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resetClientFilter]);

  const handleClientChange = async (business: Business | null) => {
    setSelectedBusiness(business ? business.clientId.toString() : '');
    dispatch(fetchAllUsers(business?.id ?? 0));
    filterByBusiness(business ?? null);
  };

  return (
    <div className="filter-container">
      <FormControl component="fieldset">
        <FormLabel component="legend" classes={{ root: 'form-label' }} focused={false}>
          Empresa
        </FormLabel>
        <FormGroup classes={{ root: 'group' }}>
          <Select
            displayEmpty
            input={<OutlinedInput />}
            className="select"
            defaultValue=""
            MenuProps={{
              PaperProps: { className: classes.paper },
              anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
              },
              transformOrigin: {
                vertical: 'top',
                horizontal: 'left',
              },
            }}
            value={selectedBusiness}
          >
            <MenuItem value="" className="select-element" onClick={() => handleClientChange(null)}>
              Todas
            </MenuItem>
            {business.businesses &&
              business.businesses.map((business) => {
                return (
                  <MenuItem
                    value={business.clientId}
                    key={business.urlName}
                    onClick={() => handleClientChange(business)}
                    className="select-element"
                  >
                    {showPlexoNames ? business.plexoCommerceName : business.prettyName}
                  </MenuItem>
                );
              })}
          </Select>
        </FormGroup>
      </FormControl>
    </div>
  );
}

export default ClientsFilter;
